import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';

import IconPath from '../../../assets/QuestionMark.svg';
import VectorSummary from '../../../assets/VectorSummary.png';
import VectorTarget from '../../../assets/VectorTarget.png';

interface UserConsentDialogProps {
    visible: boolean;
    onClose: () => void;
    onSmartGoal: () => void;
    onSummarize: () => void;
}

const UserConsentDialog: React.FC<UserConsentDialogProps> = ({
    visible,
    onClose,
    onSmartGoal,
    onSummarize,
}) => {
    return (
        <Dialog
            visible={visible}
            onHide={onClose}
            closable={false}
            header={null}
            style={{ width: '550px', borderRadius: '12px' }}
            modal
        >
            <div style={{ textAlign: 'center', padding: '1rem' }}>
                <img
                    className="notification-icon"
                    style={{ width: '48px', height: '48px', margin: '0 auto 10px' }}
                    src={IconPath}
                    alt={IconPath}
                />

                <h3 style={{ marginBottom: '0.5rem', color: '#7a3eff' }}>Discussion</h3>

                <p style={{ fontSize: '15px', marginBottom: '2rem', lineHeight: '1.4' }}>
                    Would you like to summarize or create a SMART goal for this call contents?{' '}
                    <strong>(This uses AI to analyze the call)</strong>
                </p>

                <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                    <Button
                        label="Close"
                        icon="pi pi-times"
                        className="btn-secondary me-2"
                        // style={{
                        //     borderRadius: '30px',
                        //     borderColor: '#EB419E',
                        //     color: '#EB419E',
                        // }}
                        onClick={onClose}
                    />
                    <Button
                        className="btn-primary"
                        // style={{
                        //     background: 'linear-gradient(to right, #F069DE, #6a3dfb)',
                        //     borderColor: 'linear-gradient(to right, #F069DE, #6a3dfb)',
                        //     borderRadius: '30px',
                        // }}
                        onClick={onSmartGoal}
                    >
                        <img src={VectorTarget} alt="icon" style={{ width: '16px', height: '16px' }} />
                        <span style={{ marginLeft: '8px', fontWeight: 400 }}>SMART Goal</span>
                    </Button>
                    <Button
                        className="btn-primary"
                        // style={{
                        //     background: 'linear-gradient(to right, #F069DE, #6a3dfb)',
                        //     borderColor: 'linear-gradient(to right, #F069DE, #6a3dfb)',
                        //     borderRadius: '30px',
                        // }}
                        onClick={onSummarize}
                    >
                        <img src={VectorSummary} alt="icon" style={{ width: '16px', height: '16px' }} />
                        <span style={{ marginLeft: '8px', fontWeight: 400 }}>Summarize</span>
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default UserConsentDialog;
